import metaCache from "flow/utils/metaCache";
import ko from "knockout";

export enum LoadingStatus {
    Loading,
    Success,
    Error
}

export enum SplashMode {
    Products,
    Verifying,
    WebModules
}

interface ISplashEntry {
    id: string;
    name: string;
}

export interface ISplashTask {
    id: string;
    name: string;
    status: KnockoutObservable<LoadingStatus>;
}

export const isVisible = ko.observable(true);
const mode = ko.observable<SplashMode>(SplashMode.Products);
export const disableTransition = ko.observable(false);

export const tasks = ko.observableArray<ISplashTask>([]);

export const totalCount = ko.pureComputed(() => tasks().length);
const currentCount = ko.pureComputed(() => tasks().filter(t => t.status() !== LoadingStatus.Loading).length);

export const progress = ko.pureComputed(() => {
    if (totalCount() === 0) {
        return 0;
    }

    return Math.round((currentCount() / totalCount()) * 100);
});

export const statusText = ko.pureComputed(() => {
    if (tasks().length === 0) {
        return "";
    }

    switch (mode()) {
        case SplashMode.Products:
            return metaCache.lookup("FlowHtml.Translations.ProductsChecked", "", currentCount(), totalCount());
        case SplashMode.Verifying:
            return metaCache.lookup("FlowHtml.Translations.VerifyingSelection");
        case SplashMode.WebModules:
            return metaCache.lookup("FlowHtml.Translations.ModulesLoaded", "", currentCount(), totalCount());
        default:
            return "x";
    }
});

export function addEntry(entry: ISplashEntry) {
    tasks.push({ id: entry.id, name: entry.name, status: ko.observable(LoadingStatus.Loading) });
}

export function setDone(id: string) {
    const task = tasks().find(t => t.id === id);
    if (task) {
        task.status(LoadingStatus.Success);
    }
}

export function setFailed(id: string) {
    const task = tasks().find(t => t.id === id);
    if (task) {
        task.status(LoadingStatus.Error);
    }
}

export function reset(newMode: SplashMode) {
    mode(newMode);
    disableTransition(true);
    ko.tasks.runEarly();

    tasks([]);

    window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
            // Reenable transitions, but not until progress bar has been reset
            disableTransition(false);
        });
    });
}

export function hide() {
    isVisible(false);
}
